import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"

import Grid from "@material-ui/core/Grid"

import TransportationRequestDetails from "../common/transportation/transportation-request-details"
import TransportationRequestChips from "../common/transportation/transportation-request-chips"
import TransportationOfferForm from "../common/transportation/transportation-offer-form"
import TransportationAppliedOffers from "../common/transportation/transportation-applied-offers"
import RequestDetailsSkeleton from "../common/skeleton/request-details-skeleton"
import RequestInfoSkeleton from "../common/skeleton/request-info-skeleton"
import RequestOfferSkeleton from "../common/skeleton/request-offer-skeleton"
import RequestInfo from "../common/request/request-info"
import RequestPreview from "../common/request/request-preview"
import { Panel, PanelHeader, PanelContent } from "../common/panel"

import { checkTokenExpirationMiddleware } from "../../../middlewares/users-auth.middleware"

const TransportationRequest = () => {
  let { id } = useParams()
  const [reservationRequest, setReservationRequest] = useState(null)
  const [loading, setLoading] = useState(true)
  const [, setError] = useState(null)
  const [reloadOffers, setReloadOffers] = useState(null)
  const [user] = useState(checkTokenExpirationMiddleware())
  let headers = {
    Authorization: `Bearer ${user.Token}`
  }
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/api/requests/${id}?q=transportation`, { headers: headers })
      .then(res => {
        setReservationRequest(res.data)
        setTimeout(() => setLoading(false), 750)
      })
      .catch(err => {
        setError({ error: "Error Loading page" })
      })
  }, [])

  const handleReloadOffers = () => {
    let reload = { ...reloadOffers }
    setReloadOffers(reload)
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid container item xs={12} md={12} lg={9}>
          <Panel>
            <PanelHeader>Request Details</PanelHeader>
            <PanelContent>
              {loading ? <RequestDetailsSkeleton /> : reservationRequest ? <RequestPreview label={"Transportation"} keyword={"Cities"} reservationRequest={reservationRequest} Details={<TransportationRequestDetails transportationResources={reservationRequest.reservationRequestTransportationResources} />} Chips={<TransportationRequestChips variant={"default"} customClasses={"contain-warning"} transportationResources={reservationRequest.reservationRequestTransportationResources} />} /> : null}
            </PanelContent>
          </Panel>

          <Panel>
            <PanelHeader>My Offers</PanelHeader>
            <PanelContent>{reservationRequest ? <TransportationAppliedOffers reloadOffers={reloadOffers} reservationReqId={reservationRequest.id} /> : null}</PanelContent>
          </Panel>

          <Panel>
            <PanelHeader>Add An Offer</PanelHeader>
            <PanelContent>{reservationRequest && loading === false ? <TransportationOfferForm handleReloadOffers={handleReloadOffers} reservationReqId={reservationRequest.id} /> : <RequestOfferSkeleton />}</PanelContent>
          </Panel>
        </Grid>

        <Grid container item xs={12} md={12} lg={3}>
          <div className="side-info">
            {loading ? ( //
              <RequestInfoSkeleton />
            ) : reservationRequest ? (
              <RequestInfo reservationRequest={reservationRequest} />
            ) : null}
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default TransportationRequest
